import { toast } from 'react-toastify'

import { createAxiosInstance, uploadMaxSize } from '../utils/helpers'
import { API_URL } from './index'
import * as types from './types'
import history from '../utils/history'
import { acceptedFiles } from '../utils/helpers'
import { displayMessages, getParameterByName, uploadFiles } from './common'

export function initReducer() {
	return (dispatch) => {
		dispatch({ type: types.REINICIAR_SOLICITUD_SERVICIO_OT })
	}
}

export function updateInputs(path, value) {
	return (dispatch) => {		
		const fn0 = (d) => d({ type: types.MODIFICAR_INPUTS_SOLICITUD_SERVICIO_OT, payload: { path, value } })
		fn0(dispatch);
	}
}

export function displayModalAddServicio(show, title, mode, index) {
	return (dispatch) => {
		if (show) {
			dispatch({ type: types.MOSTRAR_MODAL_AGREGAR_SERVICIO_OT_SOLICITUD_SERVICIO_OT, payload: { show, title, mode, index } })
		} else {
			dispatch({ type: types.OCULTAR_MODAL_AGREGAR_SERVICIO_OT_SOLICITUD_SERVICIO_OT })
		}
	}
}



export function addCencoSolicitudServicio() {
	return (dispatch, getState) => {
		const ordenador_gasto = getState().creacionsolicitudservicioot.get('ordenador_gasto')
		if (ordenador_gasto === null) {
			toast.warning('Seleccione primero al ordenador del gasto', { bodyClassName: 'toastify-content toastify-warning' })
		} else {
			dispatch({ type: types.ADICIONAR_NUEVO_CENCO_SOLICITUD_SERVICIO_OT })
		}
	}
}

export function removeCencosSolicitudServicio() {
	return (dispatch) => {
		dispatch({ type: types.ELIMINAR_CENCOS_SOLICITUD_SERVICIO_OT_ITEM })
	}
}

export function addSolicitudServicioItem() {
	return (dispatch, getState) => {
		const data = getState().creacionsolicitudservicioot.getIn(['modalAddServicio', 'data'])
		const errors = []
		if (!data.get('descripcion')) errors.push('La creación de servicios requiere de una descripción')
		if (data.get('cotizado') < 0) errors.push('La creación de servicios requiere que el valor del servicio sin IVA sea superior a 0')
		if (data.get('cotizado_iva') < 0) errors.push('La creación de servicios requiere que el valor total sea superior a 0')
		if (Number(data.get('cotizado_iva')) < Number(data.get('cotizado'))) errors.push('El valor total debe ser igual o superior al valor sin IVA')
		if (errors.length > 0) {
			errors.forEach(x => {
				toast.warning(x, { bodyClassName: 'toastify-content toastify-warning' })
			})
		} else {
			const fn1 = (d) => d({ type: types.ADICIONAR_NUEVO_ITEM_SOLICITUD_SERVICIO_OT })
			const fn2 = (d) => d({ type: types.OCULTAR_MODAL_AGREGAR_SERVICIO_OT_SOLICITUD_SERVICIO_OT })
			fn1(dispatch)
			fn2(dispatch)
		}
	}
}

export function removeSolicitudServicioItems() {
	return (dispatch) => {
		dispatch({ type: types.ELIMINAR_ITEMS_SOLICITUD_SERVICIO_OT })
	}
}

export function toggleSelectAllSolicitudServicioItems(checked) {
	return (dispatch) => {
		dispatch({ type: types.CONMUTAR_SELECCION_TODOS_ITEMS_SOLICITUD_SERVICIO_OT, payload: checked })
	}
}

export function toggleSelectAllSolicitudServicioFiles(checked) {
	return (dispatch) => {
		dispatch({ type: types.CONMUTAR_SELECCION_TODOS_ITEMS_FILES, payload: checked })
	}
}

export function uploadFile(file) {
	return (dispatch) => {
		const fileType = acceptedFiles.filter(x => x.type === file.type)
		let icon = '_blank.png'	
		if (fileType.length === 1) {
			icon = fileType[0].icon
		}
		const fn0 = (d) => d({ type: types.MODIFICAR_INPUTS_SOLICITUD_SERVICIO_OT, payload: { path: 'modalAddFile.data.nombre', value: file.name } })
		fn0(dispatch)
		const fn1 = (d) => d({ type: types.MODIFICAR_INPUTS_SOLICITUD_SERVICIO_OT, payload: { path: 'modalAddFile.data.file', value: file, immutable: false } })
		fn1(dispatch)
		const fn2 = (d) => d({ type: types.MODIFICAR_INPUTS_SOLICITUD_SERVICIO_OT, payload: { path: 'modalAddFile.data.icono', value: icon } })
		fn2(dispatch)
	}
}

export function addSolicitudServicioFile() {
	return (dispatch, getState) => {
		const data = getState().common.getIn(['modalAddFile', 'data'])
		const fn1 = (d) => d({ type: types.ADICIONAR_NUEVO_ARCHIVO_SOLICITUD_SERVICIO_OT, payload: data })
		fn1(dispatch)
	}
}


export function removeSolicitudServicioFiles() {
	return (dispatch) => {
		dispatch({ type: types.ELIMINAR_ARCHIVOS_SOLICITUD_SERVICIO_OT })
	}
}

export function displayModalAddFile(show, title, mode, index) {
	return (dispatch) => {
		if (show) {
			const fn0 = (d) => d(getParameterByName('CLASIFICACION_ARCHIVOS'))
			fn0(dispatch)
			dispatch({ type: types.MOSTRAR_MODAL_AGREGAR_ARCHIVO_SOLICITUD_SERVICIO_OT, payload: { show, title, mode, index } })
		} else {
			dispatch({ type: types.OCULTAR_MODAL_AGREGAR_ARCHIVO_SOLICITUD_SERVICIO_OT })
		}
	}
}

export function createSolicitudServicio() {
	const axios = createAxiosInstance()
	return (dispatch, getState) => {

		const fn0 = (d) => d({ type: types.DESHABILITAR_BOTON_GUARDAR_SOLICITUD_SERVICIO_OT, payload: true })
		const fn1 = (d) => d({ type: types.DESHABILITAR_BOTON_GUARDAR_SOLICITUD_SERVICIO_OT, payload: false })
		const fn2 = (d) => d(initReducer())
		fn0(dispatch)

		const data = getState().creacionsolicitudservicioot

		const errors = validarSolicitud(data)

		if (errors.length) {

			fn1(dispatch)

			return errors.forEach(element => {
				toast.warning(element, {bodyClassName: 'toastify-content toastify-warning'})
			});
		} else {

			let files = data.get('adjuntos')
			
			const cotizaciones = files.filter(l => l.get('clasificacion') == 'Cotizaciones')
			const cotizacionid = cotizaciones.count() > 0 ? cotizaciones.first().get('guid') : null
			const index = files.findIndex(x => x.get('guid') == cotizacionid)
	
			if (index >= 0) {
				files = files.setIn([index, 'editable'], false)
			}
	
			axios.post(`${API_URL}/solicitudes/servicios-oficina-tecnica`, data)
			.then(res => {
				const fn3 = () => history.push(window.FOLDER + '/');
				const fn4 = () => toast.success('La solicitud ha sido guardada exitosamente', { bodyClassName: 'toastify-content toastify-success' })
				dispatch(uploadFiles(`/files/${res.data.solicitud.id}`, files, [fn1, fn2, fn3, fn4]))
			})
			.catch(err => {
				console.log(err)
				displayMessages(dispatch, err)
				fn1(dispatch)
			})	

		}
	}
}

export function removeSolicitudServicioResponsable(path) {
	return (dispatch) => {
		dispatch({ type: types.ELIMINAR_RESPONSABLE_SOLICITUD_SERVICIO_OT, payload: { path } })
	}
}


export function addResponsable(payload) {
	return (dispatch, getState) => {
		const path = payload.path.split('.')[0]
		const responsables = getState().creacionsolicitudservicioot.get(path)
		if (responsables.filter(x => x.get('id') === payload.value.id).count() !== 0) {
			toast.warn(`La persona ${payload.value.fullname} ya se encuentra en el listado`, { bodyClassName: 'toastify-content toastify-warning' })
		} else {
			let responsable = getState().creacionsolicitudservicioot.getIn(payload.path.split('.')).toJS()
			responsable = {...responsable, ...payload.value}
			payload.value = responsable
			dispatch({ type: types.ADICIONAR_ELEMENTO_LISTA_SOLICITUD_SERVICIO_OT, payload })
		}
	}
}

export function addUsuarioResponsable(path) {
	return (dispatch, getState) => {
		dispatch({ type: types.ADICIONAR_NUEVO_RESPONSABLE_SOLICITUD_SERVICIO_OT, payload: path })
	}
}

export function enviarComentario() {
	return (dispatch, getState) => {		
		const guid = getState().creacionsolicitudservicioot.getIn(['comentario', 'guid'])
		const comentario = getState().creacionsolicitudservicioot.getIn(['comentario', 'texto'])
		const usuario = getState().common.get('user')
		const fn1 = (d) => d({ type: types.ENVIAR_COMENTARIO_SOLICITUD_OT, payload: {comentario, guid , usuario} })
		fn1(dispatch)
	}
}

export function editarComentario(guid) {
	return (dispatch) => {
		const fn1 = (d) => d({ type: types.EDITAR_COMENTARIO_SOLICITUD_OT, payload: {guid} })
		fn1(dispatch)
	}
}

export function eliminarComentario(guid) {
	return (dispatch) => {
		const fn1 = (d) => d({ type: types.ELIMINAR_COMENTARIO_SOLICITUD_OT, payload: { guid } })
		fn1(dispatch)
	}
}


// Shared

function validarSolicitud(data) {

	const errors = [];

	if (data.get('adjuntos').count() > 0) {

		const size = data.get('adjuntos').reduce((a, b) => { a += b.get('file').size; return a }, 0)
		if (size > uploadMaxSize.value) errors.push(`La capacidad máxima para subir archivos es de de ${uploadMaxSize.unidad}`)

		if (data.get('adjuntos').filter(x => !x.get('clasificacion')).count() > 0) errors.push('Todos los archivos deben tener una clasificación')

		if (data.get('adjuntos').filter(x => x.get('clasificacion') == 'Cotizaciones').count() == 0) errors.push('Debe haber al menos una cotización')

	}

	return errors
}




// WEBPACK FOOTER //
// ./src/actions/creacionsolicitudservicioot.js